import React from 'react';

const H5pIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="H5P"
  >
    <text
      x="12"
      y="17"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="10"
      fontWeight="700"
      fill="var(--pgn-color-headings-base)"
    >
      H5P
    </text>
  </svg>
);

export default H5pIcon;
